import { PAccordion, PText } from '@porsche-design-system/components-react';
import React, { memo } from 'react';
import { IssueCard } from './IssueCard';

export const FeatureColumn = memo(
  ({ title, epics, accordionState, onToggle, visible, versionName, columnKeyPrefix }) => {
    if (!visible) return null;

    const isUnassigned = versionName === 'Unassigned';

    return (
      <div className="w-full md:min-w-[240px] md:flex-1 md:shrink-0 rounded-xl border border-white/20 backdrop-blur-md bg-white/10 shadow-lg p-4">
        <PText className="pb-2" size="small" weight="semi-bold">
          {title}
        </PText>

        <div className="pt-2">
          {epics.map((epic, epicIndex) => {
            const issues = epic.issues.filter((issue) => {
              const versions = issue.fields.versions ?? [];
              return isUnassigned
                ? versions.length === 0
                : versions.some((v) => v.name === versionName);
            });

            const key = `${columnKeyPrefix}-${epicIndex}`;
            const isOpen = accordionState?.[key] ?? false;

            if (issues.length === 0) return null;

            return (
              <PAccordion
                key={key}
                heading={epic.name}
                headingTag="h3"
                open={isOpen}
                onUpdate={() => onToggle(key)}
              >
                {issues.map((issue) => (
                  <IssueCard key={issue.key} issue={issue} />
                ))}
              </PAccordion>
            );
          })}
        </div>
      </div>
    );
  }
);
